  import React, { useEffect, useState } from "react";
  import axios from "axios";
  import { useNavigate } from "react-router-dom";
  import {
    FaUserCircle,
    FaWallet,
    FaHistory,
    FaPlusCircle,
    FaChartLine,
    FaCoins,
    FaShieldAlt,
    FaCog,
    FaBell,
    FaCreditCard,
    FaExchangeAlt,
    FaTimes,
    FaLock,
    FaBolt,
    FaEuroSign,
    FaShoppingCart,
    FaSpinner,
    FaArrowDown,
    FaArrowUp,
    FaCheck,
    FaExclamationTriangle,
    FaCopy,
    FaFilter,
    FaListOl,
    FaSyncAlt,
    FaExternalLinkAlt,
    FaArrowLeft,
    FaArrowRight,
    FaUser,
    FaEnvelope,
    FaKey,
    FaEye,
    FaEyeSlash,
    FaCheckCircle,
    FaSave,
    FaBox
  } from "react-icons/fa";
  import { Line } from "react-chartjs-2";
  import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    Filler
  } from "chart.js";

  // ===== SWIPER PARA CARRUSEL =====
  import { Swiper, SwiperSlide } from 'swiper/react';
  import { Pagination, Autoplay } from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/pagination';

  import "../styles/AccountPage.css";

  ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler);

  export default function AccountPage() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [activeTab, setActiveTab] = useState("overview");
    const [isMobile, setIsMobile] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showAdminMenu, setShowAdminMenu] = useState(false);

    // ========== CONTADOR GLOBAL DE RETIROS ==========
    const [retiroBloqueado, setRetiroBloqueado] = useState(true);
    const [tiempoRestante, setTiempoRestante] = useState({
      dias: 365,
      horas: 0,
      minutos: 0,
      segundos: 0
    });
    const [showBloqueoModal, setShowBloqueoModal] = useState(false);

    // ========== MODALES ==========
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [showWithdrawModal, setShowWithdrawModal] = useState(false);
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [bgpAmount, setBgpAmount] = useState(1);
    const [eurAmount, setEurAmount] = useState(1.49);
    const [withdrawAmount, setWithdrawAmount] = useState(1);

    // ========== WALLET ==========
    const [withdrawWallet, setWithdrawWallet] = useState(() => {
      return localStorage.getItem('default_withdraw_wallet') || "";
    });

    // ========== CONFIGURACIÓN ==========
    const [settings, setSettings] = useState({
      name: '',
      email: '',
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [settingsLoading, setSettingsLoading] = useState(false);
    const [settingsError, setSettingsError] = useState('');
    const [settingsSuccess, setSettingsSuccess] = useState('');
    const [nameUpdateSuccess, setNameUpdateSuccess] = useState(false);
    const [passwordUpdateSuccess, setPasswordUpdateSuccess] = useState(false);

    // ========== NOTIFICACIONES ==========
    const [notificaciones, setNotificaciones] = useState([]);
    const [loadingNotificaciones, setLoadingNotificaciones] = useState(false);
    const [notificacionesNoLeidas, setNotificacionesNoLeidas] = useState(0);

    // ========== PROCESAMIENTO ==========
    const [isProcessing, setIsProcessing] = useState(false);
    const [isWithdrawing, setIsWithdrawing] = useState(false);
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [withdrawSuccess, setWithdrawSuccess] = useState(false);
    const [paymentError, setPaymentError] = useState("");
    const [withdrawError, setWithdrawError] = useState("");
    const [bgpTokenBalance, setBgpTokenBalance] = useState(0);

    // ========== HISTORIAL REAL ==========
    const [transactions, setTransactions] = useState([]);
    const [loadingTransactions, setLoadingTransactions] = useState(false);
    const [transactionsError, setTransactionsError] = useState("");
    const [tipoFiltro, setTipoFiltro] = useState('TODOS');
    const [transactionsPage, setTransactionsPage] = useState(1);
    const [transactionsLimit, setTransactionsLimit] = useState(10);
    const [transactionsPagination, setTransactionsPagination] = useState({
      current_page: 1,
      per_page: 10,
      total_items: 0,
      total_pages: 1
    });
    const [transactionsCurrentBalance, setTransactionsCurrentBalance] = useState(0);
    const [transactionsSummary, setTransactionsSummary] = useState({
      total_transactions: 0,
      types: { PURCHASE: 0, WITHDRAWAL: 0, DEPOSIT: 0 }
    });

    // ========== VERIFICACIÓN PARA CONFIGURACIÓN ==========
    const [showVerificationScreen, setShowVerificationScreen] = useState(false);
    const [verificationCode, setVerificationCode] = useState('');
    const [verificationLoading, setVerificationLoading] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [resendDisabled, setResendDisabled] = useState(false);
    const [resendTimer, setResendTimer] = useState(0);

    const navigate = useNavigate();
    const BGP_PRICE_EUR = 1.49;

    // Función para obtener la descripción de la transacción
  const getTransactionDescription = (tx) => {
    if (tx.transaction_type === 'PURCHASE') {
      // Usar la descripción del backend que ya tiene toda la info del pack
      if (tx.description) {
        return tx.description;
      }
      return `Compra de ${Math.abs(tx.amount).toFixed(2)} BGP`;
    } else if (tx.transaction_type === 'DEPOSIT') {
      // Solo mostrar DEPOSIT reales (no los de packs, que ya filtramos)
      const euroAmount = (Math.abs(tx.amount) * BGP_PRICE_EUR).toFixed(2);
      return `Depósito de ${euroAmount} €`;
    } else if (tx.transaction_type === 'WITHDRAWAL') {
      return `Retiro a wallet Solana`;
    }
    return getTransactionTypeLabel(tx.transaction_type);
  };

    // Detectar si necesita refrescar balance después de compra de pack
    useEffect(() => {
      const needsRefresh = sessionStorage.getItem('needsBalanceRefresh');
      if (needsRefresh === 'true' && user?.id) {
        console.log('🔄 Recargando balance después de compra de pack...');
        sessionStorage.removeItem('needsBalanceRefresh');
        
        // Limpiar cache y recargar todo
        localStorage.removeItem('userData');
        
        const refreshAfterPackPurchase = async () => {
          await loadUserProfile();
          await fetchBGPBalance();
          await fetchTransactions();
          
          // Mostrar mensaje de éxito
          setPaymentSuccess(true);
          setTimeout(() => setPaymentSuccess(false), 5000);
        };
        
        refreshAfterPackPurchase();
      }
    }, [user?.id]);
    
    // ========== DETECTAR MÓVIL ==========
    useEffect(() => {
      const checkMobile = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // ========== FUNCIONES ==========
    const calculateEUR = (bgp) => ((parseFloat(bgp) || 0) * BGP_PRICE_EUR).toFixed(2);
    const calculateBGP = (eur) => Math.round(((parseFloat(eur) || 0) / BGP_PRICE_EUR) * 100) / 100;

    const handleBGPChange = (value) => {
      const bgpValue = parseFloat(value) || 0;
      if (bgpValue >= 0) {
        setBgpAmount(bgpValue);
        setEurAmount(parseFloat(calculateEUR(bgpValue)));
      }
    };

    const handleEURChange = (value) => {
      const eurValue = parseFloat(value) || 0;
      if (eurValue >= 0) {
        setEurAmount(eurValue);
        setBgpAmount(calculateBGP(eurValue));
      }
    };

    const handleWithdrawAmountChange = (value) => {
      const amount = parseInt(value) || 0;
      if (amount >= 0) setWithdrawAmount(amount);
    };

    // ========== CONFIGURACIÓN ==========
    const handleSettingsChange = (e) => {
      const { name, value } = e.target;
      setSettings(prev => ({ ...prev, [name]: value }));
      setSettingsError('');
      setSettingsSuccess('');
    };

    const handleUpdateName = async () => {
      if (!settings.name.trim()) {
        setSettingsError('El nombre no puede estar vacío');
        return;
      }
      setSettingsLoading(true);
      try {
        const response = await axios.post(
          'https://reanimeitor.com/backend/update_profile.php',
          { user_id: user.id, name: settings.name.trim() },
          { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
        );
        if (response.data.success) {
          const updatedUser = { ...user, name: settings.name.trim() };
          setUser(updatedUser);
          localStorage.setItem('userData', JSON.stringify(updatedUser));
          setNameUpdateSuccess(true);
          setSettingsSuccess('Nombre actualizado correctamente');
          setTimeout(() => {
            setNameUpdateSuccess(false);
            setSettingsSuccess('');
          }, 3000);
        }
      } catch (err) {
        setSettingsError('Error al actualizar nombre');
      } finally {
        setSettingsLoading(false);
      }
    };

    const handleUpdatePassword = async () => {
      if (!settings.currentPassword) {
        setSettingsError('La contraseña actual es requerida');
        return;
      }
      if (!settings.newPassword || settings.newPassword.length < 8) {
        setSettingsError('La nueva contraseña debe tener al menos 8 caracteres');
        return;
      }
      if (settings.newPassword !== settings.confirmPassword) {
        setSettingsError('Las contraseñas no coinciden');
        return;
      }
      setSettingsLoading(true);
      try {
        const response = await axios.post(
          'https://reanimeitor.com/backend/update_password.php',
          {
            user_id: user.id,
            current_password: settings.currentPassword,
            new_password: settings.newPassword
          },
          { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
        );
        if (response.data.success) {
          setPasswordUpdateSuccess(true);
          setSettingsSuccess('Contraseña actualizada correctamente');
          setSettings(prev => ({
            ...prev,
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
          }));
          setTimeout(() => {
            setPasswordUpdateSuccess(false);
            setSettingsSuccess('');
          }, 3000);
        }
      } catch (err) {
        setSettingsError('Error al actualizar contraseña');
      } finally {
        setSettingsLoading(false);
      }
    };

    // ========== FUNCIONES DE VERIFICACIÓN PARA CONFIGURACIÓN ==========
    const handleSendVerificationCode = async () => {
      setVerificationLoading(true);
      setSettingsError('');

      try {
        const response = await axios.post(
          'https://reanimeitor.com/backend/actualizar_perfil.php',
          { accion: 'enviar_codigo' },
          {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
          }
        );

        if (response.data.success) {
          setShowVerificationScreen(true);
        } else {
          setSettingsError(response.data.error || 'Error al enviar código');
        }
      } catch (err) {
        setSettingsError('Error de conexión');
      } finally {
        setVerificationLoading(false);
      }
    };

    const handleVerifyCode = async () => {
      if (verificationCode.length !== 6) {
        setSettingsError('El código debe tener 6 dígitos');
        return;
      }

      setVerificationLoading(true);
      setSettingsError('');

      try {
        const response = await axios.post(
          'https://reanimeitor.com/backend/actualizar_perfil.php',
          {
            accion: 'verificar',
            codigo: verificationCode
          },
          {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
          }
        );

        if (response.data.success) {
          setIsVerified(true);
          setShowVerificationScreen(false);
          setVerificationCode('');
          setSettingsSuccess('¡Identidad verificada! Ya puedes realizar cambios.');
          setTimeout(() => setSettingsSuccess(''), 3000);
        } else {
          setSettingsError(response.data.error || 'Código incorrecto');
        }
      } catch (err) {
        setSettingsError('Error de conexión');
      } finally {
        setVerificationLoading(false);
      }
    };

    const handleResendCode = async () => {
      setResendDisabled(true);
      setResendTimer(60);

      const timer = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      try {
        await axios.post(
          'https://reanimeitor.com/backend/actualizar_perfil.php',
          { accion: 'enviar_codigo' },
          {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
          }
        );
      } catch (err) {
        console.error('Error reenviando código:', err);
      }
    };

    const handleUpdateNameWithVerification = async () => {
      if (!isVerified) {
        setSettingsError('Debes verificar tu identidad primero');
        return;
      }
      handleUpdateName();
    };

    const handleUpdatePasswordWithVerification = async () => {
      if (!isVerified) {
        setSettingsError('Debes verificar tu identidad primero');
        return;
      }
      handleUpdatePassword();
    };

    // ========== FUNCIÓN BALANCE BGP ==========
    const fetchBGPBalance = async () => {
      try {
        if (!user?.id) return;
        try {
          const response = await axios.get(
            `https://reanimeitor.com/backend/get_user_bgp_balance.php?user_id=${user.id}`,
            {
              headers: { 'Content-Type': 'application/json' },
              withCredentials: false,
              timeout: 5000
            }
          );
          if (response.data?.success && response.data?.balance !== undefined) {
            const balance = parseFloat(response.data.balance);
            setBgpTokenBalance(balance);
            return;
          }
        } catch (err) {
          console.log('⚠️ API no disponible, calculando desde EUR...');
        }
        if (user?.balance) {
          const balanceEUR = parseFloat(user.balance);
          const balanceBGP = balanceEUR / BGP_PRICE_EUR;
          setBgpTokenBalance(balanceBGP);
        }
      } catch (err) {
        console.error('❌ Error en fetchBGPBalance:', err);
      }
    };

    // ========== HISTORIAL ==========
    const getTransactionTypeLabel = (type) => {
      const labels = {
        'DEPOSIT': 'Depósito',
        'WITHDRAWAL': 'Retiro',
        'PURCHASE': 'Compra',
        'STAKE': 'Staking',
        'UNSTAKE': 'Unstaking',
        'REWARD': 'Recompensa',
        'TRANSFER': 'Transferencia'
      };
      return labels[type] || type;
    };

    const getStatusLabel = (status) => {
      const labels = {
        'COMPLETED': 'Completado',
        'PENDING': 'Pendiente',
        'FAILED': 'Fallido',
        'CANCELLED': 'Cancelado'
      };
      return labels[status] || status;
    };

    const formatRelativeTime = (timestamp) => {
      const now = Math.floor(Date.now() / 1000);
      const diff = now - timestamp;
      if (diff < 60) return 'hace unos segundos';
      if (diff < 3600) return `hace ${Math.floor(diff / 60)} min`;
      if (diff < 86400) return `hace ${Math.floor(diff / 3600)} h`;
      if (diff < 2592000) return `hace ${Math.floor(diff / 86400)} d`;
      return `hace ${Math.floor(diff / 2592000)} meses`;
    };

    const fetchTransactions = async () => {
    if (!user?.id) return;
    setLoadingTransactions(true);
    setTransactionsError("");
    try {
      const url = `https://reanimeitor.com/backend/get_transactions.php?user_id=${user.id}&page=${transactionsPage}&limit=${transactionsLimit}&tipo=${tipoFiltro}`;
      const response = await axios.get(url, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: false,
        timeout: 15000
      });
      if (response.data?.success) {
        // Obtener todas las transacciones
        let allTransactions = response.data.transactions || [];
        
        // Filtrar DEPOSIT duplicados que corresponden a compras de pack
        // Los DEPOSIT de packs tienen el mismo amount que el precio del pack
        const packPrices = [20, 35.76, 66.72];
        
        // Filtrar: eliminar DEPOSIT que sean de packs
        const filteredTransactions = allTransactions.filter(tx => {
          // Si es DEPOSIT y el amount coincide con precio de pack, lo filtramos
          if (tx.transaction_type === 'DEPOSIT' && packPrices.includes(Math.abs(tx.amount))) {
            return false; // No mostrar este DEPOSIT duplicado
          }
          return true;
        });
        
        setTransactions(filteredTransactions);
        setTransactionsPagination(response.data.pagination || {
          current_page: 1, per_page: 10, total_items: 0, total_pages: 1
        });
        setTransactionsCurrentBalance(response.data.current_balance || 0);
        setTransactionsSummary(response.data.summary || {
          total_transactions: 0,
          types: { PURCHASE: 0, WITHDRAWAL: 0, DEPOSIT: 0 }
        });
      } else {
        throw new Error(response.data?.message || 'Error al obtener transacciones');
      }
    } catch (err) {
      console.error('Error fetching transactions:', err);
      setTransactionsError('Error al cargar transacciones');
      setTransactions([]);
    } finally {
      setLoadingTransactions(false);
    }
  };

    // ========== CONTADOR GLOBAL ==========
    useEffect(() => {
      const FECHA_DESBLOQUEO = new Date(2027, 1, 18, 16, 0, 0).getTime();

      const calcularTiempoRestante = () => {
        const ahora = new Date().getTime();
        const diferencia = FECHA_DESBLOQUEO - ahora;

        if (diferencia <= 0) {
          setRetiroBloqueado(false);
          setTiempoRestante({ dias: 0, horas: 0, minutos: 0, segundos: 0 });
          return;
        }

        setRetiroBloqueado(true);

        const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
        const horas = Math.floor((diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
        const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);

        setTiempoRestante({ dias, horas, minutos, segundos });
      };

      calcularTiempoRestante();
      const intervalo = setInterval(calcularTiempoRestante, 1000);
      return () => clearInterval(intervalo);
    }, []);

    // ========== NOTIFICACIONES ==========
    const fetchNotificaciones = async () => {
      if (!user?.id) return;

      setLoadingNotificaciones(true);
      try {
        const response = await axios.get(
          'https://reanimeitor.com/backend/get_notificaciones.php',
          { withCredentials: true }
        );

        if (response.data.success) {
          setNotificaciones(response.data.notificaciones);
          setNotificacionesNoLeidas(response.data.no_leidas || 0);
        }
      } catch (err) {
        console.error('Error cargando notificaciones:', err);
      } finally {
        setLoadingNotificaciones(false);
      }
    };

    useEffect(() => {
      if (activeTab === "notificaciones" && user?.id) {
        fetchNotificaciones();
      }
    }, [activeTab, user?.id]);

    // ========== PAGO REAL ==========
    const handlePayment = async () => {
      if (!user?.id) {
        setPaymentError("Usuario no identificado");
        return;
      }
      if (bgpAmount < 1) {
        setPaymentError("Mínimo 1 BGP");
        return;
      }
      setIsProcessing(true);
      setPaymentError("");
      try {
        const response = await axios.post(
          'https://reanimeitor.com/backend/create_stripe_session.php',
          { user_id: user.id, amount: parseFloat(eurAmount), currency: 'eur', bgp_tokens: bgpAmount },
          { headers: { 'Content-Type': 'application/json' }, timeout: 15000 }
        );
        if (response.data.error) throw new Error(response.data.error);
        if (!response.data.checkoutUrl) throw new Error("No URL recibida");
        window.location.href = response.data.checkoutUrl;
      } catch (err) {
        setPaymentError("Error en el pago. Intenta de nuevo.");
        setIsProcessing(false);
      }
    };

    // ========== RETIRO REAL ==========
    const handleWithdraw = async () => {
      if (!user?.id) {
        setWithdrawError("Usuario no identificado");
        return;
      }
      if (!withdrawWallet?.trim()) {
        setWithdrawError("Ingresa una dirección de wallet Solana");
        return;
      }
      if (withdrawAmount <= 0) {
        setWithdrawError("Cantidad inválida");
        return;
      }
      if (withdrawAmount > bgpTokenBalance) {
        setWithdrawError(`Balance insuficiente. Disponible: ${bgpTokenBalance.toFixed(8)} BGP`);
        return;
      }

      setIsWithdrawing(true);
      setWithdrawError("");

      try {
        const response = await axios.post(
          'https://reanimeitor.com/backend/withdraw_bgp.php',
          {
            user_id: user.id,
            wallet_address: withdrawWallet,
            amount: withdrawAmount
          },
          {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
            timeout: 30000
          }
        );

        if (response.data.success) {
          setWithdrawSuccess(true);

          const newBgpBalance = bgpTokenBalance - withdrawAmount;
          setBgpTokenBalance(newBgpBalance);

          const newEurBalance = parseFloat(user.balance) - (withdrawAmount * 1.49);
          const updatedUser = {
            ...user,
            balance: newEurBalance.toFixed(2)
          };
          setUser(updatedUser);
          localStorage.setItem('userData', JSON.stringify(updatedUser));
          fetchTransactions();

          setTimeout(() => {
            setShowWithdrawModal(false);
            setWithdrawSuccess(false);
          }, 3000);
        } else {
          throw new Error(response.data.error || "Error al procesar el retiro");
        }
      } catch (err) {
        console.error('❌ Error en retiro:', err);
        setWithdrawError(err.message || "Error al procesar el retiro");
      } finally {
        setIsWithdrawing(false);
      }
    };

    // ========== REFRESCAR BALANCE ==========
    const refreshUserBalance = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const sessionId = urlParams.get('session_id');
        await new Promise(resolve => setTimeout(resolve, 2000));
        if (sessionId) {
          await axios.post(
            'https://reanimeitor.com/backend/verify_payment.php',
            { session_id: sessionId },
            { headers: { 'Content-Type': 'application/json' }, timeout: 10000 }
          );
        }
        await loadUserProfile();
        await fetchBGPBalance();
        fetchTransactions();
      } catch (err) {
        console.error("Error actualizando balance:", err);
      }
    };

    const loadUserProfile = async () => {
      try {
        const response = await axios.get(
          'https://reanimeitor.com/backend/profile.php',
          { withCredentials: true, timeout: 10000 }
        );
        if (response.data.user) {
          const userData = response.data.user;
          setUser(userData);
          localStorage.setItem('userData', JSON.stringify(userData));
          setSettings(prev => ({
            ...prev,
            name: userData.name || '',
            email: userData.email || ''
          }));
          return true;
        }
        return false;
      } catch (err) {
        console.error("Error cargando perfil:", err);
        return false;
      }
    };

    // ========== GRÁFICO ==========
    const generateChartData = () => {
      if (transactions.length > 0) {
        const last7Days = [...Array(7)].map((_, i) => {
          const date = new Date();
          date.setDate(date.getDate() - i);
          return date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' });
        }).reverse();

        let runningBalance = transactionsCurrentBalance || bgpTokenBalance;
        const balances = last7Days.map(() => {
          runningBalance = Math.max(0, runningBalance * (0.95 + Math.random() * 0.1));
          return runningBalance;
        }).reverse();

        return { labels: last7Days, balances };
      }
      return {
        labels: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
        balances: [bgpTokenBalance * 0.7, bgpTokenBalance * 0.75, bgpTokenBalance * 0.82,
        bgpTokenBalance * 0.88, bgpTokenBalance * 0.92, bgpTokenBalance * 0.97, bgpTokenBalance]
      };
    };

    const chartData = generateChartData();
    const balanceHistory = {
      labels: chartData.labels,
      datasets: [{
        label: "Balance BGP",
        data: chartData.balances,
        borderColor: "#ffcc00",
        backgroundColor: "rgba(255, 204, 0, 0.1)",
        borderWidth: 3,
        tension: 0.4,
        fill: true,
        pointBackgroundColor: "#ffcc00",
        pointBorderColor: "#000",
        pointBorderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 8
      }]
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: 'rgba(0,0,0,0.8)',
          titleColor: '#ffcc00',
          bodyColor: '#fff',
          borderColor: '#ffcc00',
          borderWidth: 1,
          cornerRadius: 8,
          callbacks: { label: (ctx) => `${ctx.raw.toFixed(2)} BGP` }
        }
      },
      scales: {
        y: {
          beginAtZero: false,
          grid: { color: 'rgba(255,255,255,0.1)' },
          ticks: { color: '#ccc', callback: (v) => v.toFixed(0) + ' BGP' }
        },
        x: {
          grid: { display: false },
          ticks: { color: '#ccc' }
        }
      }
    };

    // ========== USE EFFECTS ==========
    useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const paymentStatus = urlParams.get('payment');
      const sessionId = urlParams.get('session_id');
      const verified = localStorage.getItem(`verified_${sessionId}`);

      if (paymentStatus === 'success' && sessionId && !verified) {
        localStorage.setItem(`verified_${sessionId}`, 'true');
        setPaymentSuccess(true);
        refreshUserBalance();
        window.history.replaceState({}, document.title, window.location.pathname);
        setShowPaymentModal(false);
      }
    }, []);

    useEffect(() => {
      const fetchUser = async () => {
        try {
          const userData = localStorage.getItem('userData');
          if (userData) {
            const parsed = JSON.parse(userData);
            if (parsed?.id) {
              setUser(parsed);
              // Verificar si es admin directamente desde parsed
              if (parsed.role === 'sys_admin') {
                setIsAdmin(true);
              }
              setSettings(prev => ({ ...prev, name: parsed.name || '', email: parsed.email || '' }));
              setLoading(false);
              await fetchBGPBalance();
              fetchTransactions();
              return;
            }
          }
          const res = await axios.get(
            "https://reanimeitor.com/backend/profile.php",
            { withCredentials: true, timeout: 10000 }
          );
          if (res.data.user) {
            const userData = res.data.user;
            setUser(userData);
            // Verificar si es admin desde la respuesta de la API
            if (userData.role === 'sys_admin') {
              setIsAdmin(true);
            }
            setSettings(prev => ({ ...prev, name: userData.name || '', email: userData.email || '' }));
            localStorage.setItem('userData', JSON.stringify(userData));
            await fetchBGPBalance();
            fetchTransactions();
          } else {
            navigate("/login");
          }
        } catch (err) {
          console.error('Error cargando usuario:', err);
          navigate("/login");
        } finally {
          setLoading(false);
        }
      };
      fetchUser();
    }, [navigate]);

    useEffect(() => {
      if (user?.id) {
        fetchBGPBalance();
        fetchTransactions();
      }
    }, [user?.id, user?.balance]);

    useEffect(() => {
      if (user?.id) {
        fetchTransactions();
      }
    }, [user?.id, transactionsPage, transactionsLimit, tipoFiltro]);

    useEffect(() => {
      setEurAmount(parseFloat(calculateEUR(bgpAmount)));
    }, [bgpAmount]);

    const handleLogout = () => {
      localStorage.removeItem("userData");
      localStorage.removeItem("userToken");
      navigate("/login");
    };

    const presetBGPAmounts = [1, 5, 10, 50, 100];
    const presetWithdrawAmounts = [1, 5, 10, 20, 50];

    // ===== ACCIONES RÁPIDAS CON BLOQUEO =====
    const quickActions = [
      { icon: FaPlusCircle, label: "Comprar", color: "#ffcc00", action: () => setShowPaymentModal(true) },
      { 
        icon: retiroBloqueado ? FaLock : FaArrowDown, 
        label: retiroBloqueado ? "Bloqueado" : "Retirar", 
        color: retiroBloqueado ? "#666666" : "#ff4444", 
        action: () => retiroBloqueado ? setShowBloqueoModal(true) : setShowWithdrawModal(true),
        disabled: retiroBloqueado
      },
    ];

    // ===== CARRUSEL 1: Tokens BGP + Acciones Rápidas =====
    const carrusel1Slides = user ? [
      {
    id: 'bgp',
    component: (
      <div className="bgp-info-card carrusel-slide">
        <div className="card-header">
          <h3><FaCoins /> Tokens BGP</h3>
        </div>
        <div className="bgp-balance-display">
          <div className="bgp-amount-mobile">{bgpTokenBalance.toFixed(8)}</div>
          <div className="bgp-label-mobile">BGP TOKENS</div>
        </div>
        <div className="bgp-details-mobile">
          <div className="detail-row">
            <span>Red:</span>
            <span className="network-badge">Solana</span>
          </div>
        </div>
      </div>
    )
  },
      {
        id: 'actions',
        component: (
          <div className="quick-actions-card carrusel-slide">
            <h3 className="quick-actions-title-mobile">Acciones Rápidas</h3>
            <div className="actions-grid-mobile">
              {quickActions.map((action, i) => (
                <button 
                  key={i} 
                  className={`action-card-mobile ${action.disabled ? 'disabled' : ''}`} 
                  onClick={action.action}
                  disabled={action.disabled}
                >
                  <action.icon style={{ color: action.color }} />
                  <span>{action.label}</span>
                  {action.label === "Bloqueado" && (
                    <small className="action-small">(hasta 2027)</small>
                  )}
                </button>
              ))}
            </div>
          </div>
        )
      }
    ] : [];

    // ===== CARRUSEL 2: Rendimiento + Perfil =====
    const carrusel2Slides = user ? [
      {
        id: 'chart',
        component: (
          <div className="chart-card carrusel-slide">
            <div className="chart-header-mobile">
              <h3>Rendimiento</h3>
              <select className="time-filter-mobile">
                <option>7d</option>
                <option>30d</option>
              </select>
            </div>
            <div className="chart-container-mobile">
              <Line data={balanceHistory} options={chartOptions} />
            </div>
          </div>
        )
      },
    {
    id: 'profile',
    component: (
      <div className="user-info-card carrusel-slide">
        <h3 className="profile-title-mobile">Mi Perfil</h3>
        <div className="user-details-grid-mobile">
          <div className="detail-item">
            <span className="label">ID</span>
            <span className="value">{user.id}</span>
          </div>
          <div className="detail-item">
            <span className="label">Email</span>
            <span className="value">{user.email}</span>
          </div>
          <div className="detail-item">
            <span className="label">Nombre</span>
            <span className="value">{user.name || "—"}</span>
          </div>
          <div className="detail-item">
            <span className="label">Balance BGP</span>
            <span className="value">{bgpTokenBalance.toFixed(2)} BGP</span>
          </div>
        </div>
      </div>
    )
  }
    ] : [];

    // ===== STATS CARDS PARA CARRUSEL =====
    const statsCardsData = [
      {
        id: 'total',
        icon: <FaHistory />,
        label: 'Total',
        value: transactionsSummary?.total_transactions || 0,
        className: 'total'
      },
      {
        id: 'purchase',
        icon: <FaShoppingCart />,
        label: 'Compras',
        value: transactionsSummary?.types?.PURCHASE || 0,
        className: 'purchase'
      },
      {
        id: 'withdrawal',
        icon: <FaArrowUp />,
        label: 'Retiros',
        value: transactionsSummary?.types?.WITHDRAWAL || 0,
        className: 'withdrawal'
      },
      {
        id: 'deposit',
        icon: <FaArrowDown />,
        label: 'Depósitos',
        value: transactionsSummary?.types?.DEPOSIT || 0,
        className: 'deposit'
      },
      {
        id: 'balance',
        icon: <FaWallet />,
        label: 'Balance',
        value: transactionsCurrentBalance.toFixed(2) + ' BGP',
        className: 'balance'
      }
    ];

    if (loading) return (
      <div className="account-loading">
        <div className="loading-spinner-professional">
          <div className="energy-pulse"></div>
          <div className="loading-text">Cargando...</div>
        </div>
      </div>
    );

    if (error || !user) return (
      <div className="account-error">
        <div className="error-container">
          <div className="error-icon">⚡</div>
          <h3>Error</h3>
          <p>{error || "No se cargaron datos"}</p>
          <button onClick={() => navigate("/login")} className="energy-btn primary">Reconectar</button>
        </div>
      </div>
    );

    return (
      <div className="account-professional">
        {/* ========== MODAL CONFIGURACIÓN CON VERIFICACIÓN ========== */}
        {showSettingsModal && (
          <div className="payment-modal-overlay">
            <div className="payment-modal settings-modal">
              <div className="modal-header">
                <h3><FaCog /> Configuración de Cuenta</h3>
                <button className="modal-close-btn" onClick={() => {
                  setShowSettingsModal(false);
                  setSettingsError('');
                  setSettingsSuccess('');
                  setShowVerificationScreen(false);
                  setVerificationCode('');
                }}>
                  <FaTimes />
                </button>
              </div>
              <div className="modal-body">
                {settingsSuccess && (
                  <div className="settings-success-message">
                    <FaCheckCircle /> {settingsSuccess}
                  </div>
                )}
                {settingsError && (
                  <div className="settings-error-message">
                    <FaExclamationTriangle /> {settingsError}
                  </div>
                )}

                {/* PANTALLA DE VERIFICACIÓN */}
                {showVerificationScreen ? (
                  <div className="verification-screen">
                    <div className="verification-icon">
                      <FaLock className="verification-lock-icon" />
                    </div>
                    <h4>Verifica tu identidad</h4>
                    <p className="verification-description">
                      Hemos enviado un código de verificación a:<br />
                      <strong>{user?.email}</strong>
                    </p>
                    <p className="verification-instructions">
                      Revisa tu bandeja de entrada (y spam). El código expira en 15 minutos.
                    </p>

                    <div className="verification-code-input">
                      <input
                        type="text"
                        maxLength="6"
                        placeholder="000000"
                        value={verificationCode}
                        onChange={(e) => {
                          setVerificationCode(e.target.value.replace(/[^0-9]/g, '').slice(0, 6));
                          setSettingsError('');
                        }}
                        className="code-input-field"
                        autoFocus
                        disabled={verificationLoading}
                      />
                    </div>

                    <div className="verification-actions">
                      <button
                        className="verify-btn"
                        onClick={handleVerifyCode}
                        disabled={verificationCode.length !== 6 || verificationLoading}
                      >
                        {verificationLoading ? (
                          <><FaSpinner className="spinning-icon" /> Verificando...</>
                        ) : (
                          'Verificar código'
                        )}
                      </button>

                      <button
                        className="resend-code-btn"
                        onClick={handleResendCode}
                        disabled={resendDisabled || verificationLoading}
                      >
                        {resendDisabled ? `Reenviar en ${resendTimer}s` : 'Reenviar código'}
                      </button>
                    </div>

                    <button
                      className="back-to-settings-btn"
                      onClick={() => {
                        setShowVerificationScreen(false);
                        setVerificationCode('');
                        setSettingsError('');
                      }}
                    >
                      <FaArrowLeft /> Volver a configuración
                    </button>
                  </div>
                ) : (
                  /* PANTALLA PRINCIPAL DE CONFIGURACIÓN */
                  <>
                    <div className="settings-section">
                      <div className="settings-section-header">
                        <FaUser /> <h4>Información Personal</h4>
                      </div>
                      <div className="settings-field-group">
                        <label className="settings-label"><FaEnvelope /> Email</label>
                        <input type="email" value={settings.email} disabled className="settings-input disabled" />
                      </div>
                      <div className="settings-field-group">
                        <label className="settings-label"><FaUser /> Nombre</label>
                        <div className="settings-field-with-action">
                          <input
                            type="text"
                            name="name"
                            value={settings.name}
                            onChange={handleSettingsChange}
                            placeholder="Tu nombre"
                            className="settings-input"
                            disabled={!isVerified}
                          />
                          <button
                            className={`settings-action-btn ${nameUpdateSuccess ? 'success' : ''}`}
                            onClick={() => handleUpdateNameWithVerification()}
                            disabled={settingsLoading || !settings.name.trim() || settings.name === user.name || !isVerified}
                          >
                            {settingsLoading ? <FaSpinner className="spinning-icon" /> : nameUpdateSuccess ? <FaCheck /> : <FaSave />}
                            <span>Actualizar</span>
                          </button>
                        </div>
                        {!isVerified && (
                          <p className="verification-warning">
                            <FaExclamationTriangle /> Debes verificar tu identidad para cambiar el nombre
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="settings-section">
                      <div className="settings-section-header">
                        <FaKey /> <h4>Cambiar Contraseña</h4>
                      </div>
                      <div className="settings-field-group">
                        <label className="settings-label"><FaLock /> Actual</label>
                        <div className="password-input-wrapper">
                          <input
                            type={showCurrentPassword ? "text" : "password"}
                            name="currentPassword"
                            value={settings.currentPassword}
                            onChange={handleSettingsChange}
                            placeholder="••••••••"
                            className="settings-input"
                            disabled={!isVerified}
                          />
                          <button type="button" className="password-toggle-btn" onClick={() => setShowCurrentPassword(!showCurrentPassword)}>
                            {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>
                      </div>
                      <div className="settings-field-group">
                        <label className="settings-label"><FaLock /> Nueva</label>
                        <div className="password-input-wrapper">
                          <input
                            type={showNewPassword ? "text" : "password"}
                            name="newPassword"
                            value={settings.newPassword}
                            onChange={handleSettingsChange}
                            placeholder="Mínimo 8 caracteres"
                            className="settings-input"
                            disabled={!isVerified}
                          />
                          <button type="button" className="password-toggle-btn" onClick={() => setShowNewPassword(!showNewPassword)}>
                            {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>
                      </div>
                      <div className="settings-field-group">
                        <label className="settings-label"><FaLock /> Confirmar</label>
                        <div className="password-input-wrapper">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirmPassword"
                            value={settings.confirmPassword}
                            onChange={handleSettingsChange}
                            placeholder="Repite tu contraseña"
                            className="settings-input"
                            disabled={!isVerified}
                          />
                          <button type="button" className="password-toggle-btn" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>
                      </div>
                      {!isVerified && (
                        <p className="verification-warning">
                          <FaExclamationTriangle /> Debes verificar tu identidad para cambiar la contraseña
                        </p>
                      )}
                      <button
                        className={`settings-password-btn ${passwordUpdateSuccess ? 'success' : ''}`}
                        onClick={handleUpdatePasswordWithVerification}
                        disabled={settingsLoading || !settings.currentPassword || !settings.newPassword ||
                          settings.newPassword.length < 8 || settings.newPassword !== settings.confirmPassword || !isVerified}
                      >
                        {settingsLoading ? <><FaSpinner className="spinning-icon" /> Actualizando...</> :
                          passwordUpdateSuccess ? <><FaCheck /> Contraseña actualizada</> :
                            <><FaKey /> Cambiar contraseña</>}
                      </button>
                    </div>

                    {/* BOTÓN PARA INICIAR VERIFICACIÓN */}
                    {!isVerified && (
                      <div className="verify-account-section">
                        <button
                          className="verify-account-btn"
                          onClick={handleSendVerificationCode}
                          disabled={verificationLoading}
                        >
                          {verificationLoading ? (
                            <><FaSpinner className="spinning-icon" /> Enviando código...</>
                          ) : (
                            <><FaLock /> Verificar identidad para realizar cambios</>
                          )}
                        </button>
                      </div>
                    )}

                    {isVerified && (
                      <div className="verified-badge">
                        <FaCheckCircle /> Identidad verificada - Puedes realizar cambios
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ========== MODAL RETIRO ========== */}
        {showWithdrawModal && (
          <div className="payment-modal-overlay">
            <div className="payment-modal withdraw-modal">
              <div className="modal-header">
                <h3><FaArrowDown /> Retirar BGP</h3>
                <button className="modal-close-btn" onClick={() => {
                  setShowWithdrawModal(false);
                  setWithdrawError("");
                  setWithdrawSuccess(false);
                }}>
                  <FaTimes />
                </button>
              </div>
              <div className="modal-body">
                {withdrawSuccess ? (
                  <div className="payment-success-message">
                    <div className="success-icon">✅</div>
                    <h4>¡Retiro Solicitado!</h4>
                    <p>{withdrawAmount} BGP serán enviados a:</p>
                    <p className="wallet-success-address">{withdrawWallet}</p>
                    <button className="energy-btn primary" onClick={() => setShowWithdrawModal(false)}>Cerrar</button>
                  </div>
                ) : (
                  <>
                    <div className="withdraw-balance-card">
                      <div className="balance-display">
                        <span className="balance-label">BGP Disponibles:</span>
                        <span className="balance-amount">{bgpTokenBalance.toFixed(8)} BGP</span>
                      </div>
                      <div className="balance-value">≈ €{(bgpTokenBalance * BGP_PRICE_EUR).toFixed(2)}</div>
                    </div>

                    <div className="wallet-input-section">
                      <h4><FaWallet /> Dirección Solana:</h4>
                      <textarea
                        value={withdrawWallet}
                        onChange={(e) => {
                          setWithdrawWallet(e.target.value);
                          localStorage.setItem('default_withdraw_wallet', e.target.value);
                        }}
                        placeholder="F6BZwmrso2kDmGkgLDV2TTW9GqykdSC8Bd29AfMCNBCr"
                        className="wallet-address-textarea"
                        rows="2"
                      />
                      <div className="wallet-input-actions">
                        <button className="wallet-action-btn" onClick={() => navigator.clipboard.writeText(withdrawWallet)}>
                          <FaCopy /> Copiar
                        </button>
                      </div>
                    </div>

                    <div className="withdraw-amount-section">
                      <h4><FaCoins /> Cantidad:</h4>
                      <div className="preset-grid">
                        {presetWithdrawAmounts.map((amount) => (
                          <button key={amount} className={`preset-btn ${withdrawAmount === amount ? 'selected' : ''}`}
                            onClick={() => handleWithdrawAmountChange(amount)}>
                            <div className="preset-bgp">{amount} BGP</div>
                            <div className="preset-eur">≈ {calculateEUR(amount)}€</div>
                          </button>
                        ))}
                      </div>
                      <div className="custom-withdraw-amount">
                        <div className="input-group">
                          <label>Cantidad personalizada:</label>
                          <div className="input-with-suffix">
                            <input type="number" min="1" step="1" value={withdrawAmount}
                              onChange={(e) => handleWithdrawAmountChange(e.target.value)} className="amount-input" />
                            <span className="input-suffix">BGP</span>
                          </div>
                        </div>
                        <div className="amount-summary">
                          <div className="summary-item">
                            <span>Retirarás:</span>
                            <strong>{withdrawAmount} BGP</strong>
                          </div>
                          <div className="summary-item">
                            <span>Valor:</span>
                            <strong className="total-amount">{calculateEUR(withdrawAmount)}€</strong>
                          </div>
                        </div>
                      </div>
                    </div>

                    {withdrawError && <div className="payment-error-message">{withdrawError}</div>}

                    <button onClick={handleWithdraw} disabled={isWithdrawing || withdrawAmount <= 0 ||
                      withdrawAmount > bgpTokenBalance || !withdrawWallet.trim()} className="withdraw-pay-button">
                      {isWithdrawing ? <><FaSpinner className="spinning-icon" /> Procesando...</> :
                        <><FaArrowDown /> Retirar {withdrawAmount} BGP</>}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ========== MODAL PAGO ========== */}
        {showPaymentModal && (
          <div className="payment-modal-overlay">
            <div className="payment-modal">
              <div className="modal-header">
                <h3><FaShoppingCart /> Comprar BGP</h3>
                <button className="modal-close-btn" onClick={() => {
                  setShowPaymentModal(false);
                  setPaymentError("");
                  setPaymentSuccess(false);
                }}>
                  <FaTimes />
                </button>
              </div>
              <div className="modal-body">
                {paymentSuccess ? (
                  <div className="payment-success-message">
                    <div className="success-icon">✅</div>
                    <h4>¡Pago Completado!</h4>
                    <p>Tus {bgpAmount} BGP se han añadido a tu cuenta.</p>
                    <button className="energy-btn primary" onClick={() => {
                      setShowPaymentModal(false);
                      setPaymentSuccess(false);
                      refreshUserBalance();
                    }}>Continuar</button>
                  </div>
                ) : (
                  <>
                    <div className="price-info">
                      <div className="price-tag"><FaBolt /> 1 BGP = {BGP_PRICE_EUR}€</div>
                    </div>
                    <div className="preset-amounts-section">
                      <h4>Cantidad:</h4>
                      <div className="preset-grid">
                        {presetBGPAmounts.map((amount) => (
                          <button key={amount} className={`preset-btn ${bgpAmount === amount ? 'selected' : ''}`}
                            onClick={() => handleBGPChange(amount)}>
                            <div className="preset-bgp">{amount} BGP</div>
                            <div className="preset-eur">{calculateEUR(amount)}€</div>
                          </button>
                        ))}
                      </div>
                    </div>
                    <div className="custom-amount-section">
                      <div className="amount-inputs">
                        <div className="input-group">
                          <label><FaCoins /> BGP:</label>
                          <div className="input-with-suffix">
                            <input type="number" min="1" step="0.1" value={bgpAmount}
                              onChange={(e) => handleBGPChange(e.target.value)} className="amount-input" />
                            <span className="input-suffix">BGP</span>
                          </div>
                        </div>
                        <div className="conversion-arrow">⇅</div>
                        <div className="input-group">
                          <label><FaEuroSign /> EUR:</label>
                          <div className="input-with-suffix">
                            <input type="number" min="1.49" step="0.01" value={eurAmount}
                              onChange={(e) => handleEURChange(e.target.value)} className="amount-input" />
                            <span className="input-suffix">€</span>
                          </div>
                        </div>
                      </div>
                      <div className="amount-summary">
                        <div className="summary-item">
                          <span>Total:</span>
                          <strong className="total-amount">{eurAmount.toFixed(2)}€</strong>
                        </div>
                        <div className="summary-item">
                          <span>Recibirás:</span>
                          <strong className="future-balance">{bgpAmount.toFixed(2)} BGP</strong>
                        </div>
                      </div>
                    </div>
                    {paymentError && <div className="payment-error-message">{paymentError}</div>}
                    <button onClick={handlePayment} disabled={isProcessing || bgpAmount < 1} className="stripe-pay-button">
                      {isProcessing ? <><FaSpinner className="spinning-icon" /> Procesando...</> :
                        <><FaCreditCard /> Pagar {eurAmount.toFixed(2)}€</>}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ========== MODAL DE BLOQUEO DE RETIROS ========== */}
        {showBloqueoModal && (
          <div className="payment-modal-overlay">
            <div className="payment-modal bloqueo-modal">
              <div className="modal-header">
                <h3><FaLock /> Retiros Bloqueados</h3>
                <button className="modal-close-btn" onClick={() => setShowBloqueoModal(false)}>
                  <FaTimes />
                </button>
              </div>
              <div className="modal-body">
                <div className="bloqueo-icono">
                  <FaLock className="bloqueo-lock" />
                </div>
                
                <h4>Función de retiro temporalmente deshabilitada</h4>
                
                <p className="bloqueo-descripcion">
                  Por medidas de seguridad, los retiros están bloqueados durante los primeros 365 días desde el lanzamiento.
                </p>
                
                <div className="bloqueo-contador-grande">
                  <div className="contador-grid">
                    <div className="contador-cuadro">
                      <span className="contador-valor">{tiempoRestante.dias}</span>
                      <span className="contador-unidad">Días</span>
                    </div>
                    <div className="contador-cuadro">
                      <span className="contador-valor">{tiempoRestante.horas.toString().padStart(2, '0')}</span>
                      <span className="contador-unidad">Horas</span>
                    </div>
                    <div className="contador-cuadro">
                      <span className="contador-valor">{tiempoRestante.minutos.toString().padStart(2, '0')}</span>
                      <span className="contador-unidad">Min</span>
                    </div>
                    <div className="contador-cuadro">
                      <span className="contador-valor">{tiempoRestante.segundos.toString().padStart(2, '0')}</span>
                      <span className="contador-unidad">Seg</span>
                    </div>
                  </div>
                </div>
                
                <p className="bloqueo-nota">
                  ⚡ Mientras tanto, puedes seguir comprando tokens y acumulando energía.
                </p>
                
                <button 
                  className="bloqueo-btn-entendido"
                  onClick={() => setShowBloqueoModal(false)}
                >
                  Entendido
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ========== HEADER ========== */}
        <div className="account-energy-field">
          <div className="energy-bolt"></div>
          <div className="energy-bolt"></div>
        </div>

        <div className="account-dashboard-header">
          <div className="user-welcome">
            <div className="user-avatar">
              <FaUserCircle className="avatar-icon" />
              <div className="online-status"></div>
            </div>
            <div className="welcome-text">
              <h1>{user.name || "Usuario"}</h1>
              <p>{isMobile ? "📱 Móvil" : "💻 Escritorio"}</p>
            </div>
          </div>
          <div className="header-actions">
            <button className="header-btn" onClick={() => setActiveTab("notificaciones")}>
              <FaBell />
              {notificacionesNoLeidas > 0 && (
                <span className="notification-badge">{notificacionesNoLeidas}</span>
              )}
            </button>

            <button className="header-btn" onClick={() => setShowSettingsModal(true)}>
              <FaCog />
            </button>
            {/* Menú de administración - solo visible para sys_admin */}
            {isAdmin && (
              <>
                <button 
                  className="header-btn admin-direct-btn" 
                  onClick={() => navigate('/home/config_view_products')}
                  title="Ver Pedidos"
                >
                  <FaBox /> Pedidos
                </button>
                <div className="admin-menu-container">
                  <a 
        href="https://reanimeitor.com/blog/panel.php" 
        target="_blank" 
        rel="noopener noreferrer"
        className="header-btn admin-btn"
      >
        <FaBolt /> Panel
      </a>
                </div>
              </>
            )}
        
          </div>
        </div>

       <div className="account-tabs">
  <button className={`tab-btn ${activeTab === "overview" ? "active" : ""}`}
    onClick={() => setActiveTab("overview")}><FaChartLine /> Resumen</button>
</div>

        <div className="account-content-professional">
          {activeTab === "overview" ? (
            <>
              {/* ===== BALANCE PRINCIPAL (SIEMPRE VISIBLE) ===== */}
              <div className="main-balance-card">
                <div className="balance-header">
                  <div className="balance-title"><FaWallet /> Balance Total</div>
                  <div className="balance-trend positive">+{(Math.random() * 15 + 5).toFixed(1)}%</div>
                </div>
                <div className="balance-amount-main">
                  {user.balance ? parseFloat(user.balance/ BGP_PRICE_EUR).toFixed(2) : "0.00"}  BGP
                </div>
              
                
                {/* ===== BALANCE ACTIONS CON BLOQUEO ===== */}
                <div className="balance-actions">
                  <button className="energy-btn primary" onClick={() => setShowPaymentModal(true)}>
                    <FaPlusCircle /> Comprar BGP
                  </button>
                  <button 
                    className={`energy-btn secondary ${retiroBloqueado ? 'bloqueado' : ''}`} 
                    onClick={() => retiroBloqueado ? setShowBloqueoModal(true) : setShowWithdrawModal(true)} 
                    disabled={retiroBloqueado || bgpTokenBalance <= 0}
                  >
                    {retiroBloqueado ? (
                      <>
                        <FaLock /> Retiro bloqueado
                      </>
                    ) : (
                      <>
                        <FaArrowDown /> Retirar BGP
                      </>
                    )}
                  </button>
                </div>

                {/* CONTADOR DE BLOQUEO */}
                {retiroBloqueado && (
                  <div className="retiro-contador">
                    <div className="contador-titulo">
                      <FaLock /> Retiros bloqueados hasta el 18/02/2027
                    </div>
                    <div className="contador-tiempo">
                      <div className="contador-item">
                        <span className="contador-numero">{tiempoRestante.dias}</span>
                        <span className="contador-label">días</span>
                      </div>
                      <div className="contador-separador">:</div>
                      <div className="contador-item">
                        <span className="contador-numero">{tiempoRestante.horas.toString().padStart(2, '0')}</span>
                        <span className="contador-label">horas</span>
                      </div>
                      <div className="contador-separador">:</div>
                      <div className="contador-item">
                        <span className="contador-numero">{tiempoRestante.minutos.toString().padStart(2, '0')}</span>
                        <span className="contador-label">min</span>
                      </div>
                      <div className="contador-separador">:</div>
                      <div className="contador-item">
                        <span className="contador-numero">{tiempoRestante.segundos.toString().padStart(2, '0')}</span>
                        <span className="contador-label">seg</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* ===== VERSIÓN DESKTOP (grid normal) ===== */}
              {!isMobile && (
                <>
                <div className="bgp-info-card">
    <div className="card-header">
      <h3><FaCoins /> Tokens BGP</h3>
    </div>
    <div className="bgp-balance-display">
      <div className="bgp-amount">{bgpTokenBalance.toFixed(8)}</div>
      <div className="bgp-label">BGP TOKENS</div>
    </div>
    <div className="bgp-details">
      <div className="detail-row">
        <span>Red:</span>
        <span className="network-badge">Solana</span>
      </div>
    </div>
  </div>

                  <div className="quick-actions-card">
                    <h3>Acciones Rápidas</h3>
                    <div className="actions-grid">
                      {quickActions.map((action, i) => (
                        <button 
                          key={i} 
                          className={`action-card ${action.disabled ? 'disabled' : ''}`} 
                          onClick={action.action}
                          disabled={action.disabled}
                        >
                          <action.icon style={{ color: action.color }} />
                          <span>{action.label}</span>
                          {action.label === "Bloqueado" && (
                            <small className="action-small">(hasta 2027)</small>
                          )}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="chart-card">
                    <div className="chart-header">
                      <h3>Rendimiento del Balance</h3>
                      <select className="time-filter">
                        <option>7 días</option>
                        <option>30 días</option>
                      </select>
                    </div>
                    <div className="chart-container">
                      <Line data={balanceHistory} options={chartOptions} />
                    </div>
                  </div>

                  <div className="user-info-card">
    <h3>Información del Perfil</h3>
    <div className="user-details-grid">
      <div className="detail-item">
        <span className="label">ID</span>
        <span className="value">{user.id}</span>
      </div>
      <div className="detail-item">
        <span className="label">Email</span>
        <span className="value">{user.email}</span>
      </div>
      <div className="detail-item">
        <span className="label">Nombre</span>
        <span className="value">{user.name || "—"}</span>
      </div>
      <div className="detail-item">
        <span className="label">Balance BGP</span>
        <span className="value">{bgpTokenBalance.toFixed(2)} BGP</span>
      </div>
    </div>
  </div>
                </>
              )}

              {/* ===== VERSIÓN MÓVIL (CARRUSELES REDIMENSIONADOS) ===== */}
              {isMobile && (
                <>
                  <div className="carrusel-container">
                    <Swiper
                      modules={[Pagination, Autoplay]}
                      spaceBetween={12}
                      slidesPerView={1}
                      pagination={{ clickable: true, dynamicBullets: true }}
                      autoplay={{ delay: 4000, disableOnInteraction: false }}
                      loop={true}
                      className="carrusel-account"
                    >
                      {carrusel1Slides.map((slide) => (
                        <SwiperSlide key={slide.id}>
                          {slide.component}
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>

                  <div className="carrusel-container">
                    <Swiper
                      modules={[Pagination, Autoplay]}
                      spaceBetween={12}
                      slidesPerView={1}
                      pagination={{ clickable: true, dynamicBullets: true }}
                      autoplay={{ delay: 5000, disableOnInteraction: false }}
                      loop={true}
                      className="carrusel-account"
                    >
                      {carrusel2Slides.map((slide) => (
                        <SwiperSlide key={slide.id}>
                          {slide.component}
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </>
              )}
            </>
          ) : activeTab === "notificaciones" ? (
            <div className="notificaciones-tab-content">
              <div className="section-header">
                <h2><FaBell /> Centro de Notificaciones</h2>
                <p>Todos los emails que te hemos enviado</p>
              </div>

              {loadingNotificaciones ? (
                <div className="loading-notificaciones">
                  <div className="spinner"></div>
                  <p>Cargando notificaciones...</p>
                </div>
              ) : notificaciones.length === 0 ? (
                <div className="empty-notificaciones">
                  <FaBell className="empty-icon" />
                  <h3>No hay notificaciones</h3>
                  <p>Cuando te enviemos emails, aparecerán aquí</p>
                </div>
              ) : (
                <div className="notificaciones-list">
                  {notificaciones.map((notif) => (
                    <div key={notif.id} className={`notificacion-item ${!notif.leido ? 'no-leido' : ''}`}>
                      <div className="notificacion-icon">{notif.icono}</div>
                      <div className="notificacion-content">
                        <div className="notificacion-header">
                          <h4>{notif.asunto}</h4>
                          <span className="notificacion-fecha">
                            {new Date(notif.fecha).toLocaleDateString('es-ES', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </span>
                        </div>
                        <div className="notificacion-tipo">
                          {notif.titulo_tipo}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <div className="history-tab-content">
              <div className="transactions-header-main">
                <h2><FaHistory /> Historial de Transacciones</h2>
                <p>Todas tus transacciones de BGP</p>
              </div>

              <div className="transactions-controls">
                <div className="filters-row">
                  <div className="filter-group">
                    <label><FaFilter /> Tipo:</label>
                    <select className="filter-select" value={tipoFiltro}
                      onChange={(e) => { setTipoFiltro(e.target.value); setTransactionsPage(1); }}>
                      <option value="TODOS">📋 Todas</option>
                      <option value="PURCHASE">🛒 Compras</option>
                      <option value="WITHDRAWAL">⬆️ Retiros</option>
                      <option value="DEPOSIT">⬇️ Depósitos</option>
                    </select>
                  </div>
                  <div className="filter-group">
                    <label><FaListOl /> Mostrar:</label>
                    <select className="filter-select" value={transactionsLimit}
                      onChange={(e) => setTransactionsLimit(parseInt(e.target.value))}>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                  <button className="refresh-btn-history" onClick={fetchTransactions} disabled={loadingTransactions}>
                    {loadingTransactions ? <FaSpinner className="spinning-icon" /> : <FaSyncAlt />} Actualizar
                  </button>
                </div>
              </div>

              {/* ===== STATS CARDS - DESKTOP ===== */}
              {!isMobile && (
                <div className="transactions-stats-cards">
                  <div className="stat-card">
                    <div className="stat-icon total"><FaHistory /></div>
                    <div className="stat-content">
                      <span className="stat-label">Total</span>
                      <span className="stat-value">{transactionsSummary?.total_transactions || 0}</span>
                    </div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-icon purchase"><FaShoppingCart /></div>
                    <div className="stat-content">
                      <span className="stat-label">Compras</span>
                      <span className="stat-value">{transactionsSummary?.types?.PURCHASE || 0}</span>
                    </div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-icon withdrawal"><FaArrowUp /></div>
                    <div className="stat-content">
                      <span className="stat-label">Retiros</span>
                      <span className="stat-value">{transactionsSummary?.types?.WITHDRAWAL || 0}</span>
                    </div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-icon deposit"><FaArrowDown /></div>
                    <div className="stat-content">
                      <span className="stat-label">Depósitos</span>
                      <span className="stat-value">{transactionsSummary?.types?.DEPOSIT || 0}</span>
                    </div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-icon balance"><FaWallet /></div>
                    <div className="stat-content">
                      <span className="stat-label">Balance</span>
                      <span className="stat-value">{transactionsCurrentBalance.toFixed(2)} BGP</span>
                    </div>
                  </div>
                </div>
              )}

              {/* ===== STATS CARDS - MÓVIL (CARRUSEL) ===== */}
              {isMobile && (
                <div className="carrusel-container stats-carrusel">
                  <Swiper
                    modules={[Pagination, Autoplay]}
                    spaceBetween={10}
                    slidesPerView={1.2}
                    centeredSlides={true}
                    pagination={{ clickable: true, dynamicBullets: true }}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    loop={true}
                    className="stats-carousel"
                  >
                    {statsCardsData.map((stat) => (
                      <SwiperSlide key={stat.id}>
                        <div className="stat-card-mobile">
                          <div className={`stat-icon-mobile ${stat.className}`}>
                            {stat.icon}
                          </div>
                          <div className="stat-content-mobile">
                            <span className="stat-label-mobile">{stat.label}</span>
                            <span className="stat-value-mobile">{stat.value}</span>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              )}

              <div className="transactions-table-container">
                {loadingTransactions ? (
                  <div className="loading-transactions">
                    <div className="spinner-large"></div>
                    <p>Cargando transacciones...</p>
                  </div>
                ) : transactionsError ? (
                  <div className="transactions-error-message">
                    <FaExclamationTriangle className="error-icon" />
                    <h4>Error</h4>
                    <p>{transactionsError}</p>
                    <button className="retry-btn" onClick={fetchTransactions}>Reintentar</button>
                  </div>
                ) : transactions.length === 0 ? (
                  <div className="empty-transactions">
                    <FaHistory className="empty-icon-large" />
                    <h4>No hay transacciones</h4>
                    <p>Cuando realices compras o retiros, aparecerán aquí</p>
                    <button className="action-btn-empty" onClick={() => { setActiveTab("overview"); setShowPaymentModal(true); }}>
                      <FaPlusCircle /> Comprar BGP
                    </button>
                  </div>
                ) : (
                  <>
                    <div className="transactions-table">
                      <div className="table-header">
                        <div className="header-cell type">Tipo</div>
                        <div className="header-cell description">Descripción</div>
                        <div className="header-cell amount">Cantidad (BGP)</div>
                        <div className="header-cell status">Estado</div>
                        <div className="header-cell date">Fecha</div>
                      </div>
                      <div className="table-body">
                        {transactions.map((tx) => (
                          <div key={tx.id} className={`table-row ${tx.transaction_type.toLowerCase()}`}>
                            <div className="table-cell type" data-label="Tipo">
                              <div className="type-icon">
                                {tx.transaction_type === 'PURCHASE' && <FaShoppingCart />}
                                {tx.transaction_type === 'WITHDRAWAL' && <FaArrowUp />}
                                {tx.transaction_type === 'DEPOSIT' && <FaArrowDown />}
                              </div>
                              <span className="type-name">{getTransactionTypeLabel(tx.transaction_type)}</span>
                            </div>
                            <div className="table-cell description" data-label="Descripción">
                              {getTransactionDescription(tx)}
                            </div>
                            <div className="table-cell amount" data-label="Cantidad">
                              <span className={`amount-value ${tx.amount > 0 ? 'positive' : 'negative'}`}>
                                {tx.amount > 0 ? '+' : ''}{Math.abs(tx.amount).toFixed(8)} BGP
                              </span>
                            </div>
                            <div className="table-cell status" data-label="Estado">
                              <span className={`status-badge ${tx.status.toLowerCase()}`}>
                                {tx.status === 'COMPLETED' && <FaCheck />}
                                {tx.status === 'PENDING' && <FaSpinner className="spinning-icon-small" />}
                                {getStatusLabel(tx.status)}
                              </span>
                            </div>
                            <div className="table-cell date" data-label="Fecha">
                              <div className="date-relative">{formatRelativeTime(tx.created_at_timestamp)}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {transactionsPagination.total_pages > 1 && (
                      <div className="table-pagination">
                        <button className="pagination-btn" onClick={() => setTransactionsPage(p => Math.max(1, p - 1))}
                          disabled={transactionsPage === 1}>
                          <FaArrowLeft /> Anterior
                        </button>
                        <div className="pagination-pages">
                          {Array.from({ length: Math.min(3, transactionsPagination.total_pages) }, (_, i) => {
                            let pageNum = transactionsPage <= 2 ? i + 1 : transactionsPage - 1 + i;
                            if (pageNum > transactionsPagination.total_pages) return null;
                            return (
                              <button key={pageNum} className={`page-number ${transactionsPage === pageNum ? 'active' : ''}`}
                                onClick={() => setTransactionsPage(pageNum)}>
                                {pageNum}
                              </button>
                            );
                          })}
                        </div>
                        <button className="pagination-btn" onClick={() => setTransactionsPage(p => Math.min(transactionsPagination.total_pages, p + 1))}
                          disabled={transactionsPage === transactionsPagination.total_pages}>
                          Siguiente <FaArrowRight />
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
        </div>

        {paymentSuccess && !showPaymentModal && (
          <div className="global-success-message">
            <div className="success-content">
              <span className="success-icon">✅</span>
              <span>¡Pago completado! Tu saldo se ha actualizado.</span>
              <button className="success-close" onClick={() => setPaymentSuccess(false)}>×</button>
            </div>
          </div>
        )}

        {withdrawSuccess && !showWithdrawModal && (
          <div className="global-success-message withdraw-success">
            <div className="success-content">
              <span className="success-icon">✅</span>
              <span>¡Retiro solicitado! Los BGP serán enviados a tu wallet.</span>
              <button className="success-close" onClick={() => setWithdrawSuccess(false)}>×</button>
            </div>
          </div>
        )}
      </div>
    );
  }